import { useEffect } from 'react';
import { useActiveLab, useDispatch } from '@witmetrics/data-store';
import { useAppState } from '@/providers/AppStateProvider';
import { useToggle } from '@/hooks/useToggle';
import Overlay from '@/components/Overlay';
import OrderInfoColumn from './OrderInfoColumn';
import TabsColumn from './TabsColumn';
import { classes, fetchLabOrderData } from './utils';

export default function LabOrderOverlay() {
  const dispatch = useDispatch();
  const { onApiError, activeOrderId, onClearActiveOrder } = useAppState();
  const activeLab = useActiveLab();
  const [isFetchingData, toggleFetchingData] = useToggle(true);
  const [isFetchingFiles, toggleFetchingFiles] = useToggle(true);
  const [isInfoCollapsed, toggleInfoCollapsed] = useToggle();

  useEffect(() => {
    if (!activeOrderId || !activeLab) return;
    fetchData();
    fetchFileData();
  }, [activeOrderId, activeLab]);

  const fetchData = async () => {
    try {
      toggleFetchingData(true);
      const results = await fetchLabOrderData(activeOrderId!, activeLab!.id);
      dispatch.addOrders([results.order]);
      dispatch.addOrderNotes(results.notes);
      dispatch.addOrderTasks(results.tasks);
      dispatch.addOrderKeypoints(results.keypoints);
      dispatch.addLabUsers(results.labUsers);
      dispatch.addKeypointTypes(results.keypointTypes);
      if (results.labPractice) {
        dispatch.addLabPractices([results.labPractice]);
      }
      toggleFetchingData(false);
    } catch (err) {
      onApiError(err, 'Error fetching order data', () => fetchData());
    }
  };

  const fetchFileData = async () => {
    try {
      toggleFetchingFiles(true);
      // eslint-disable-next-line witmetrics/no-multiline-comments
      /* TODO
      // const results = await fetchProjectFiles(activeProjectId!);
      // dispatch(
      //   dispatchAddUnisonProjectFileCollection(
      //     results.unisonProjectFileCollection
      //   )
      // );
      // dispatch(dispatchSetFileCollectionFiles(results.fileCollectionFiles));
      // dispatch(dispatchSetFileNotes(results.fileNotes));
      // dispatch(dispatchSetFileCollections(results.fileCollections));
       */
      toggleFetchingFiles(false);
    } catch (err) {
      onApiError(err, 'Error fetching files', () => fetchFileData());
    }
  };

  if (!activeOrderId) return null;

  return (
    <Overlay className={classes.overlay} onClose={onClearActiveOrder}>
      <OrderInfoColumn
        isFetchingData={isFetchingData}
        collapsed={isInfoCollapsed}
        onToggleCollapsed={toggleInfoCollapsed}
      />
      <TabsColumn isFetchingData={isFetchingData} />
    </Overlay>
  );
}
